// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3kGPT","overflowing":"ReadFullNote_overflowing__1W0vn"};